import { Component } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

import { AssignmentParticipantRegistrationDetailModel } from '../../../models/assignment-participants/assignment-participant-registration-detail.model';
import { AssignmentParticipantModel } from '../../../models/assignment-participants/assignment-participant.model';
import { AssignmentParticipantsStateService } from '../../../services/assignments-participants-state.service';
import { AssignmentParticipantRegistrationDetailsModalComponent } from '../assignment-participant-registration-details-modal/assignment-participant-registration-details-modal.component';

@Component({
    selector: 'app-assignment-participants-list',
    templateUrl: './assignment-participants-list.component.html',
    styleUrl: './assignment-participants-list.component.scss'
})
export class AssignmentParticipantsListComponent {

    private maxParticipantsDisplayed: number = 12;
    protected isParticipantsCountRestricted: boolean = true;

    constructor(
        private bsModalService: BsModalService,
        protected assignmentParticipantStateService: AssignmentParticipantsStateService
    ) { }


    protected get sortedAndFilteredParticipants(): AssignmentParticipantModel[] {
        let participants = this.assignmentParticipantStateService.assignmentParticipantsSubject.getValue();
        if (participants == null) return [];

        participants = participants.sort((a, b) => {
            return (a.firstName + a.lastName).localeCompare((b.firstName + b.lastName));
        });

        participants.forEach(x => {
            x.registrationDetails = x.registrationDetails.sort((a, b) => a.questionSort - b.questionSort);
            x.registrationDetails = x.registrationDetails.filter(x => x.answer != '');
        });

        if (this.isParticipantsCountRestricted) {
            participants = participants.slice(0, this.maxParticipantsDisplayed);
        }

        return participants
    }

    protected get hasMoreThenMaxParticipants(): boolean {
        let participants = this.assignmentParticipantStateService.assignmentParticipantsSubject.getValue();
        if (participants == null) return false;

        return participants.length > this.maxParticipantsDisplayed;
    }

    protected openRegistrationDetailsModal(person: AssignmentParticipantModel, registrationDetails: AssignmentParticipantRegistrationDetailModel[]): void {
        this.bsModalService.show(AssignmentParticipantRegistrationDetailsModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                registrationDetails: registrationDetails,
                personFullName: `${person.firstName} ${person.lastName}`
            }
        });
    }
}
